/*
|--------------------------------------------------------------------------
| Wellgard Recommendation Engine
|--------------------------------------------------------------------------
| recommendation-engine.js
|--------------------------------------------------------------------------
*/

window.Wellgard = window.Wellgard || {};

(function () {

    /**
     * Configuration
     */
    const CONFIG = {

        PRIMARY_SCORE: 10,

        SECONDARY_SCORE: 1,

        AGE_50_PLUS_BONUS: 1,

        MAX_RESULTS: 4,

        DEBUG: true

    };


    /**
     * Public API
     */
    window.Wellgard.recommend = function (answers) {

        if (CONFIG.DEBUG) {
            console.log("====================================");
            console.log("Wellgard Recommendation Engine");
            console.log("Answers:", answers);
        }

        const products = initialiseProducts();

        scoreGoals(products, answers);

        applySpecialRules(products, answers);

        applyAgeBonus(products, answers);

        filterProducts(products, answers);

        sortProducts(products);

        const recommendations = products
            .filter(product => product.score > 0)
            .slice(0, CONFIG.MAX_RESULTS);

        if (CONFIG.DEBUG) {

            console.log("====================================");
            console.log("Final Recommendations");

            console.table(
                recommendations.map(product => ({
                    Product: product.title,
                    Score: product.score,
                    Reasons: product.reasons.join(" | ")
                }))
            );

        }        

        return {
            answers,
            recommendations
        };


       
    };


    /**
     * Returns score for a product
     */
    window.Wellgard.getScore = function(productId, answers){

        const results = window.Wellgard.recommend(answers);

        const product = results.find(p => String(p.id) === String(productId));

        return product ? product.score : 0;

    };

    /**
     * Returns a product by Shopify ID
     */
    window.Wellgard.getProduct = function(id){

        return window.Wellgard.Products[id] || null;

    };

    // Debug Helper
    window.Wellgard.debug = function(answers){

        const products = window.Wellgard.recommend(answers);

        console.table(products);

        return products;

    };



    /**
     * Build working product array
     */
    function initialiseProducts() {

        return Object.values(window.Wellgard.Products).map(product => ({

            ...product,

            score: 0,

            reasons: []

        }));

    }


    /**
     * Goal scoring
     */
    function scoreGoals(products, answers){


        const goals = answers.goals || [];


        console.log(
            "Scoring goals:",
            goals
        );


        products.forEach(product=>{


            product.score = 0;

            product.reasons = [];



            goals.forEach(goal=>{


                if(
                    product.primary &&
                    product.primary.includes(goal)
                ){

                    product.score += 10;

                    product.reasons.push(
                        `${goal} Primary +10`
                    );

                }



                if(
                    product.secondary &&
                    product.secondary.includes(goal)
                ){

                    product.score += 1;

                    product.reasons.push(
                        `${goal} Secondary +1`
                    );

                }


            });


           


        });





    }

    /**
     * Apply special scoring rules
     */
    function applySpecialRules(products, answers) {
        
        const selectedGoals = answers.goals || [];


        
        const userDiet = getDiet(answers); // array of user diet selections
        const gender = getGender(answers);

        Object.values(products).forEach(product => {

            if (!product.special) product.special = {}; // Ensure object exists

            // Split customer symptoms into individual phrases if present
            const customerSymptoms = answers.symptoms
                ? answers.symptoms.split(",").map(s => s.trim().toLowerCase()).filter(Boolean)
                : [];

            // Split stress answer into individual phrases if present
            const customerStress = answers.stress
                ? answers.stress.split(",").map(s => s.trim().toLowerCase()).filter(Boolean)
                : [];

            // Loop through all keys in product.special
            Object.keys(product.special).forEach(ruleKey => {

                const ruleValue = product.special[ruleKey]; // e.g., symptom keyword
                if (!ruleValue) return;

                // -------------------------------
                // Digestion rules
                // -------------------------------
                if (ruleKey === "digestion") {

                    const keyword = ruleValue.toLowerCase();

                    const matched = customerSymptoms.some(symptom =>
                        symptom.includes(keyword)
                    );

                    if (matched) {
                        product.score += product.special.score || 0;
                        product.reasons.push(
                            `Direct match: +${product.special.score || 0} from digestion "${ruleValue}"`
                        );
                    }
                }

                // -------------------------------
                // Stress rules
                // -------------------------------
                if (ruleKey === "stress") {

                    const keyword = ruleValue.toLowerCase();

                    const matched = customerStress.some(stress =>
                        stress.includes(keyword)
                    );

                    if (matched) {
                        product.score += product.special.score || 1; // default +1 if score not defined
                        product.reasons.push(
                            `Direct match: +${product.special.score || 1} from stress "${ruleValue}"`
                        );
                    }
                }

                // -------------------------------
                // Future special rules can be added here
                // -------------------------------
            });

            
            // Collagen Powder Priority Boost
            // -------------------------------
           

            // -------------------------------
            // Collagen Powder Priority Boost
            // -------------------------------
            const collagenHandles = ["collagen-powder", "halal-collagen-powder"];
            const collagenGoals = ["Healthy Skin", "Beautiful Hair", "Stronger Nails"];
            const goalMatch = selectedGoals.some(goal => collagenGoals.includes(goal));

            if (collagenHandles.includes(product.handle) && goalMatch) {

                // Normalize user diet
                let userDiet = [];
                if (answers.diet) {
                    if (Array.isArray(answers.diet)) {
                        userDiet = answers.diet;
                    } else if (typeof answers.diet === "string") {
                        userDiet = answers.diet.split(",").map(d => d.trim());
                    }
                }

                // Determine which variant to boost
                if (userDiet.includes("Halal")) {
                    // Only Halal variant gets +10
                    if (product.handle === "halal-collagen-powder") {
                        product.score += 10;
                        product.reasons.push("Priority boost: Halal Collagen for skin/hair/nail goals");
                    } else if (product.handle === "collagen-powder") {
                        product.score = 0; // hide regular variant
                    }
                } else {
                    // Only regular Collagen gets +10 if Halal not selected
                    if (product.handle === "collagen-powder") {
                        product.score += 10;
                        product.reasons.push("Priority boost: Collagen Powder for skin/hair/nail goals");
                    } else if (product.handle === "halal-collagen-powder") {
                        product.score = 0; // hide Halal variant
                    }
                }
            }




        });

    }

    /**
     * Audience bonus
     */
    function applyAgeBonus(products, answers) {

        const age = findAnswer(
            answers,
            window.Wellgard.Constants.AGE.AGE_50_PLUS
        );

        if (!age) return;

        products.forEach(product => {

            if (product.audience !== "50+") return;

            product.score += CONFIG.AGE_50_PLUS_BONUS;

            product.reasons.push(
                "+1 Audience Bonus (50+)"
            );

        });

    }


    /**
     * Remove products user should not see
     */
    function filterProducts(products, answers) {

        const gender = getGender(answers);

        const diet = getDiet(answers);

        for (let i = products.length - 1; i >= 0; i--) {

            const product = products[i];

            //-----------------------------------------
            // Inactive products
            //-----------------------------------------

            if (
                product.active === false ||
                product.includeInQuiz === false
            ) {

                products.splice(i,1);

                continue;

            }
            //-----------------------------------------
            // Gender exclusion
            //-----------------------------------------

            if (
                product.exclude &&
                product.exclude === gender
            ) {

                products.splice(i, 1);

                continue;

            }

            //-----------------------------------------
            // Diet filtering
            //-----------------------------------------

            if (
                diet &&
                diet !== window.Wellgard.Constants.DIET.KOSHER &&
                diet !== window.Wellgard.Constants.DIET.PESCATARIAN
            ) {

                if (
                    product.diet.length &&
                    !product.diet.includes(diet)
                ) {

                    products.splice(i, 1);

                    continue;

                }

            }

        }

    }

    function sortProducts(products) {

        products.sort((a, b) => {

            if (b.score !== a.score) {

                return b.score - a.score;

            }

            return a.title.localeCompare(b.title);

        });

    }

    function getGender(answers) {

        return findAnswer(
            answers,
            window.Wellgard.Constants.GENDER.MALE,
            window.Wellgard.Constants.GENDER.FEMALE
        );

    }

    function getDiet(answers) {

        return findAnswer(
            answers,
            window.Wellgard.Constants.DIET.VEGAN,
            window.Wellgard.Constants.DIET.VEGETARIAN,
            window.Wellgard.Constants.DIET.HALAL,
            window.Wellgard.Constants.DIET.KOSHER,
            window.Wellgard.Constants.DIET.PESCATARIAN
        );

    }

    function hasAnswer(answers, value) {

        return !!findAnswer(answers, value);

    }

    function findAnswer(answers, ...values) {

        const list = Object.values(answers).flat();

        return list.find(item => values.includes(item));

    }


    /**
     * Reads all selected goals
     *
     * Supports:
     *
     * Goal 1
     * Goal 2
     *
     * or array values
     *
     */
    function getSelectedGoals(answers) {

        const goals = [];

        Object.entries(answers).forEach(([question, answer]) => {

            //-----------------------------------------
            // Array answers
            //-----------------------------------------

            if (Array.isArray(answer)) {

                answer.forEach(value => {

                    if (typeof value === "string") {

                        goals.push(value);

                    }

                });

            }

            //-----------------------------------------
            // Single answer
            //-----------------------------------------

            else if (typeof answer === "string") {

                goals.push(answer);

            }

        });

        //-----------------------------------------
        // Remove duplicates
        //-----------------------------------------

        return [...new Set(goals)];

    }

})();